import { Box, Typography } from "@mui/material";

interface RecordAuditFooterProps {
  subtitle?: string | null;
  mt?: string | number;
}

const RecordAuditFooter: React.FC<RecordAuditFooterProps> = ({
  subtitle,
  mt = "20px",
}) => {
  if (!subtitle) return null;

  return (
    <Box>
      <Typography fontSize="small" sx={{ textAlign: "right", marginTop: mt }}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default RecordAuditFooter;
